import React, { useEffect, useState } from "react";
import Game from "./pages/Game";
import EndPage from "./pages/EndPage";
import CustomLogin from "./pages/CustomLogin";
import { Routes, Route } from "react-router-dom";
import PasswordPage from "./pages/PasswordPage";

const loadFontFace = (family, url, weight = "400") => {
  if (!url) return;

  const face = new FontFace(family, `url(${url})`, { weight });
  face
    .load()
    .then(loadedFace => {
      const fontSet = document["fonts"];
      if (fontSet && typeof fontSet["add"] === "function") {
        fontSet["add"](loadedFace);
      }
    })
    .catch(() => {});
};

const loadFontFamily = (family, config = {}) => {
  loadFontFace(family, config.regular_font, "400");
  loadFontFace(family, config.medium_font, "500");
  loadFontFace(family, config.bold_font, "700");
  loadFontFace(family, config.extra_bold_font, "800");
};

const App = ({ isIframe }) => {
  const [teamAction, setTeamAction] = useState([]);
  const [wheelData, setWheelData] = useState([]);
  const [onLogin, setLogin] = useState(false);

  const addTeamAction = data => {
    setTeamAction([...teamAction, data]);
  };

  const addWheelData = data => {
    setWheelData([...wheelData, data]);
  };

  const Login = () => {
    setLogin(true);
  };

  const deleteTeamAction = data => {
    var global = [...teamAction];

    for (var i = 0; i < global.length; i++) {
      if (global[i] === data) {
        global.splice(i, 1);
        setTeamAction(global);
        break;
      }
    }
  };

  const updateTeamAction = data => {
    var global = [...teamAction];
    global.push(data);
    setTeamAction(global);
  };

  useEffect(() => {
    const globalFonts = window["fonts"] || {};
    const headingConfig = globalFonts.heading || {};
    const bodyConfig = globalFonts.body || {};

    loadFontFamily("Custom Fonts Heading", headingConfig);
    loadFontFamily("Custom Fonts Body", bodyConfig);
  }, []);

  const defaultRoutes = [
      <Route
        key="home"
        path="/"
        element={
          <Game
            addWheelData={addWheelData}
            login={onLogin}
            addTeamAction={addTeamAction}
            isIframe={isIframe}
          />
        }
      />,
      <Route
        key="end-page"
        path="/end-page"
        element={
          <EndPage
            deleteTeamAction={deleteTeamAction}
            updateTeamAction={updateTeamAction}
            teamAction={teamAction}
          />
        }
      />,
      <Route
        key="password-page"
        path="/password-page"
        element={<PasswordPage wheelData={wheelData} login={Login} />}
      />,
      <Route
        key="login"
        path="/login"
        element={
          <CustomLogin />
        }
      />
  ];

  return (
    <Routes>
      <React.Fragment>
        {defaultRoutes}
      </React.Fragment>
    </Routes>
  );
};

export default App;
